import React, { Component } from 'react';
import { Modal, Button } from 'antd';
import ResetPasswordRequestBody from 'components/login/ResetPasswordRequestBody';

export default class ResetPasswordRequest extends Component {
    constructor(props) { super(props); }

    isDisabled = () => {
        const
        { emailId } = this.props.state.passwordReset,
        { validation } = this.props.state.captcha;
        return validation.status === 'success' && emailId.length > 0 ? false : true;
    }

    render() {
        const
        { services, state, changeModal, handleDisplay, modalProps } = this.props,
        { request, emailId } = state.passwordReset,
        { captcha } = state;

        return (
            <div style={{ amrginTop: '20px' }}>
                <Modal {...{...modalProps,
                    closable: request.status == 'success' || request.status == 'failure' ? false : true,
                    maskClosable: request.status == 'success' || request.status == 'failure' ? false : true,
                    onCancel: () => {
                        handleDisplay();
                        setTimeout(function() {
                            services.resetCaptchaValidation();
                            services.clearResetField('emailId');
                            services.clearRequestPasswordReset();
                        }, 1000);
                    },
                    footer: request.status !== 'success' ? (
                        <div>
                            <Button
                                size='small'
                                type='default'
                                icon='left'
                                onClick={() => {
                                    changeModal('login');
                                    services.resetCaptchaValidation();
                                }}
                                style={{ width: '90px', marginRight: '107px'}}
                            >{'Back'}
                            </Button>
                            <Button
                                size='small'
                                type='default'
                                onClick={() => {
                                    handleDisplay();
                                    services.clearResetField('emailId');
                                    services.resetCaptchaValidation();
                                }}
                                style={{ width: '90px' }}
                            >{'Cancel'}
                            </Button>
                            <Button
                                icon={request.status === 'failure' ? 'rollback' : ''}
                                size='small'
                                type='primary'
                                style={{ width: '185px' }}
                                onClick={() => {
                                    switch(request.status) {
                                        case 'failure':
                                            services.clearResetField('emailId');
                                            services.resetCaptchaValidation();
                                            services.clearRequestPasswordReset();
                                            break;
                                        default: services.requestPasswordReset(emailId, captcha.field);
                                    }
                                }}
                                disabled={this.isDisabled()}
                            >{request.status === 'failure' ? 'Retry' : 'Request Password Reset'}
                            </Button>
                        </div>
                    ) : null
                }}>
                    <ResetPasswordRequestBody {...this.props} />
                </Modal>
            </div>
        );
    }
}
